import {
  ImageIcon,
  MessageSquareIcon,
  CodeIcon,
  PencilIcon,
  MusicIcon,
  VideoIcon,
} from 'lucide-react'
export type App = {
  id: string
  title: string
  author: string
  description: string
  rating: number
  reviews: string
  category: string
  icon: string
  iconBg: string
  downloads: string
  price: 'Free' | 'Paid'
  createdBy: string
  aisUsed: string[]
  updated: string
  version: string
  size: string
}
export const mockApps: App[] = [
  {
    id: 'image-wizard-pro',
    title: 'Image Wizard Pro',
    author: 'John Smith',
    description:
      'Advanced image generation with custom styles and modifications',
    rating: 4.8,
    reviews: '2.3k',
    category: 'Image Generation',
    icon: 'image',
    iconBg: 'bg-purple-500',
    downloads: '100K+',
    price: 'Free',
    createdBy: 'AI Labs Inc.',
    aisUsed: ['DALL-E', 'Stable Diffusion', 'Midjourney'],
    updated: 'June 1, 2023',
    version: '2.1.0',
    size: '24 MB',
  },
  {
    id: 'chatmaster-ai',
    title: 'ChatMaster AI',
    author: 'Sarah Chen',
    description: 'Intelligent conversation partner for various topics',
    rating: 4.9,
    reviews: '1.8k',
    category: 'Chat & Conversation',
    icon: 'message-square',
    iconBg: 'bg-blue-500',
    downloads: '50K+',
    price: 'Free',
    createdBy: 'AI Chat Labs',
    aisUsed: ['GPT-4', 'Claude'],
    updated: 'May 15, 2023',
    version: '1.5.0',
    size: '18 MB',
  },
  {
    id: 'codecraft-ai',
    title: 'CodeCraft AI',
    author: 'Dev Team',
    description: 'Smart code generation and optimization tool',
    rating: 4.7,
    reviews: '956',
    category: 'Development',
    icon: 'code',
    iconBg: 'bg-green-500',
    downloads: '25K+',
    price: 'Paid',
    createdBy: 'CodeCraft Inc.',
    aisUsed: ['Copilot', 'CodeLLaMA'],
    updated: 'June 10, 2023',
    version: '2.0.1',
    size: '32 MB',
  },
  {
    id: 'cooking-helper',
    title: 'Cooking Helper',
    author: 'Chef AI Team',
    description:
      'Your personal AI sous chef for recipes, meal planning, and cooking tips',
    rating: 4.9,
    reviews: '3.1k',
    category: 'Food & Cooking',
    icon: 'chef-hat',
    iconBg: 'bg-orange-500',
    downloads: '75K+',
    price: 'Free',
    createdBy: 'Culinary AI Labs',
    aisUsed: ['GPT-4', 'Claude'],
    updated: 'June 15, 2023',
    version: '3.2.0',
    size: '28 MB',
  },
  {
    id: 'ghiblifi',
    title: 'Ghiblifi',
    author: 'Studio Dreams AI',
    description:
      'Transform any scene into beautiful Studio Ghibli-style artwork',
    rating: 4.8,
    reviews: '4.5k',
    category: 'Digital Art',
    icon: 'sparkles',
    iconBg: 'bg-emerald-500',
    downloads: '120K+',
    price: 'Free',
    createdBy: 'Dream Canvas Inc.',
    aisUsed: ['Stable Diffusion', 'ControlNet', 'LoRA'],
    updated: 'June 12, 2023',
    version: '2.5.0',
    size: '52 MB',
  },
  {
    id: 'eli5-explanations',
    title: 'ELI5 - Easy Explanations',
    author: 'Learning AI Co',
    description:
      'Complex topics explained simply, as if you were five years old',
    rating: 4.9,
    reviews: '2.8k',
    category: 'Education & Learning',
    icon: 'lightbulb',
    iconBg: 'bg-yellow-500',
    downloads: '60K+',
    price: 'Free',
    createdBy: 'EduTech AI',
    aisUsed: ['GPT-4', 'Claude'],
    updated: 'June 8, 2023',
    version: '1.8.0',
    size: '20 MB',
  },
  {
    id: 'art-generator',
    title: 'Art Generator',
    author: 'Creative AI Labs',
    description: 'Create stunning digital art with AI',
    rating: 4.6,
    reviews: '1.2k',
    category: 'Digital Art',
    icon: 'pencil',
    iconBg: 'bg-red-400',
    downloads: '30K+',
    price: 'Free',
    createdBy: 'Creative AI Labs',
    aisUsed: ['Stable Diffusion', 'MidJourney'],
    updated: 'May 20, 2023',
    version: '1.2.0',
    size: '45 MB',
  },
  {
    id: 'story-writer',
    title: 'Story Writer',
    author: 'Narrative AI',
    description: 'AI-powered creative writing assistant',
    rating: 4.8,
    reviews: '876',
    category: 'Content Creation',
    icon: 'pencil',
    iconBg: 'bg-blue-400',
    downloads: '15K+',
    price: 'Paid',
    createdBy: 'Narrative AI Inc.',
    aisUsed: ['GPT-4', 'Claude'],
    updated: 'June 5, 2023',
    version: '1.1.0',
    size: '22 MB',
  },
  {
    id: 'music-creator',
    title: 'Music Creator',
    author: 'AI Sound Labs',
    description: 'Create original music with AI',
    rating: 4.7,
    reviews: '654',
    category: 'Audio Generation',
    icon: 'music',
    iconBg: 'bg-purple-400',
    downloads: '20K+',
    price: 'Free',
    createdBy: 'AI Sound Labs',
    aisUsed: ['MusicLM', 'AudioCraft'],
    updated: 'May 25, 2023',
    version: '1.3.0',
    size: '56 MB',
  },
  {
    id: 'video-editor',
    title: 'Video Editor AI',
    author: 'Visual AI Team',
    description: 'AI-powered video editing and enhancement',
    rating: 4.5,
    reviews: '432',
    category: 'Video Processing',
    icon: 'video',
    iconBg: 'bg-green-400',
    downloads: '10K+',
    price: 'Paid',
    createdBy: 'Visual AI Inc.',
    aisUsed: ['Runway', 'D-ID'],
    updated: 'June 8, 2023',
    version: '1.0.2',
    size: '78 MB',
  },
]
export type Review = {
  id: string
  userId: string
  userName: string
  rating: number
  comment: string
  date: string
}
export const mockReviews: Review[] = [
  {
    id: '1',
    userId: 'user1',
    userName: 'Sarah K.',
    rating: 5,
    comment: 'Great app! Really helps with my workflow.',
    date: '2023-06-01',
  },
  {
    id: '2',
    userId: 'user2',
    userName: 'Mike R.',
    rating: 4,
    comment: 'Very useful tool, but could use some UI improvements.',
    date: '2023-05-28',
  },
  {
    id: '3',
    userId: 'user3',
    userName: 'Alex M.',
    rating: 5,
    comment: 'Amazing results! Worth every penny.',
    date: '2023-06-10',
  },
]
